<script>
    import {apiUrl} from '../config.svelte';

    import {onMount,onDestroy} from 'svelte';
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    import { Table,Button, Input, Card,CardBody,Label} from 'sveltestrap';
    import LineInfo from './LineInfo.svelte'
    import Activity from './Activity.svelte'
    
    /* objects */
    let activities=[]
    /* html variables */
    let sub=undefined;
    let chosenActivity=undefined;

    onMount(()=>{
        fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"activities"}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
           if(x.result){
               activities=x.data;
           }
        })
        .catch((e)=>{

        })
    })
</script>

<div style="position:absolute;width:300px;height:100%;overflow:auto;">
    <Button block size="sm" color="success" on:click={()=>{sub="lineInfo"}} >line info</Button>
    {#each activities as activity}
        <Button block size="sm" color="info" on:click={()=>{chosenActivity=activity;sub="activity"}} >{activity.activity}</Button>
    {/each}
</div>
<div style="position:absolute;left:300px;width:calc(100% - 300px);height:100%">
    {#if sub=="lineInfo"}
        <LineInfo />
    {:else if sub=="activity" && chosenActivity}
        <Activity bind:chosenActivity={chosenActivity} />
    {/if}
</div>